import { FC, useEffect, useState } from 'react';

import { Dialog, useDialog } from 'components';
import { useCustomerAPI } from 'hooks/use-customer-api';
import useTimeZone from 'hooks/use-timezone';
import { Customer, EDIType } from 'types';

export const BulkResendEdiDialog: FC<{
  open: boolean;
  handleClose: () => void;
  customer: Customer | null;
}> = ({ customer, open, handleClose }) => {
  const { openDialog, ref, closeDialog } = useDialog();
  const { resendBulkEdi } = useCustomerAPI();
  const { newZonedDayJs, zonedStartOfDay, zonedEndOfDay } = useTimeZone();

  const [gate, setGate] = useState<boolean>(false);
  const [lift, setLift] = useState<boolean>(false);
  const [status, setStatus] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<string>(newZonedDayJs().toISOString().substring(0, 10));
  const [endDate, setEndDate] = useState<string>(newZonedDayJs().toISOString().substring(0, 10));

  useEffect(() => {
    if (open) {
      openDialog();
    } else {
      closeDialog();
    }
  }, [open, closeDialog, openDialog]);

  const handleResend = () => {
    if (!customer) return;
    if (gate)
      resendBulkEdi(
        customer.id,
        EDIType.GATE,
        zonedStartOfDay(startDate).toISOString(),
        zonedEndOfDay(endDate).toISOString()
      );
    if (lift)
      resendBulkEdi(
        customer.id,
        EDIType.LIFT,
        zonedStartOfDay(startDate).toISOString(),
        zonedEndOfDay(endDate).toISOString()
      );
    if (status)
      resendBulkEdi(
        customer.id,
        EDIType.STATUS,
        zonedStartOfDay(startDate).toISOString(),
        zonedEndOfDay(endDate).toISOString()
      );

    handleClose();
  };

  return (
    <Dialog closeDialog={handleClose} ref={ref}>
      <h3 className="page-header text-primary-dark header-border-bottom">EDI Recipients</h3>
      <div className={`grid-3 p-2 align-items-center margin-bottom-16px`}>
        <span className="d-flex justify-content-center">GATE</span>
        <span className="d-flex justify-content-center">LIFT</span>
        <span className="d-flex justify-content-center">STATUS</span>
        <input key="GATE" type="checkbox" checked={gate} onChange={() => setGate(!gate)} />
        <input key="LIFT" type="checkbox" checked={lift} onChange={() => setLift(!lift)} />
        <input key="STATUS" type="checkbox" checked={status} onChange={() => setStatus(!status)} />
      </div>
      <h6 className="text-info-dark">START DATE</h6>
      <input
        type="date"
        className="mt-2 w-100 margin-bottom-16px"
        onChange={e => setStartDate(e.target.value)}
        value={startDate}
        max={endDate}
        required
      />
      <h6 className="text-info-dark">END DATE</h6>
      <input
        type="date"
        className="mt-2 w-100 margin-bottom-16px"
        onChange={e => setEndDate(e.target.value)}
        value={endDate}
        min={startDate}
        max={newZonedDayJs().toISOString()}
        required
      />
      <div className="d-flex justify-content-between">
        <button className="btn-outline text-uppercase" onClick={handleClose}>
          Cancel
        </button>
        <button className="btn-primary text-uppercase" onClick={handleResend}>
          Resend
        </button>
      </div>
    </Dialog>
  );
};
